import { QueryResult } from '@app/analytics/metric-widget/data-objects/query-result';

export class LiveDataQueryResults {
  constructor(public lightLevel: QueryResult<number>, public presenceLevel: QueryResult<number>) {}
}
